module.exports = __webpack_public_path__ + "static/media/mute_52324.cfa72456.svg";